export default "__VITE_ASSET__a902638f__"